/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyUserAdminDto } from '../models/CompanyUserAdminDto';
import type { GetCurrentCompanyUserClientResponse } from '../models/GetCurrentCompanyUserClientResponse';
import type { Pagination1OfCompanyUserListedAdminDto } from '../models/Pagination1OfCompanyUserListedAdminDto';
import type { PostCompanyUserBulkAdminRequest } from '../models/PostCompanyUserBulkAdminRequest';
import type { PutCompanyUserAdminRequest } from '../models/PutCompanyUserAdminRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CompanyUsersService {
    /**
     * @returns GetCurrentCompanyUserClientResponse OK
     * @throws ApiError
     */
    public static getCurrentCompanyUserClient(): CancelablePromise<GetCurrentCompanyUserClientResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/companyusers/current',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCompanyUsers`
     * @returns CompanyUserAdminDto OK
     * @throws ApiError
     */
    public static getCompanyUserAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<CompanyUserAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/companyusers/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCompanyUsers`
     * @returns any OK
     * @throws ApiError
     */
    public static putCompanyUserAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCompanyUserAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/companyusers/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCompanyUsers`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteCompanyUserAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/companyusers/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCompanyUsers`
     * @returns Pagination1OfCompanyUserListedAdminDto OK
     * @throws ApiError
     */
    public static getCompanyUsersAdmin({
        companyId,
        companySearchWord,
        userSearchWord,
        mealTierId,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        companyId?: number,
        companySearchWord?: string,
        userSearchWord?: string,
        mealTierId?: number,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfCompanyUserListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/companyusers',
            query: {
                'companyId': companyId,
                'companySearchWord': companySearchWord,
                'userSearchWord': userSearchWord,
                'mealTierId': mealTierId,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCompanyUsers`
     * @returns any OK
     * @throws ApiError
     */
    public static postCompanyUserBulkAdmin({
        requestBody,
    }: {
        requestBody?: PostCompanyUserBulkAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/companyusers/bulk',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
